import type { Coverage } from "./common.ts";

type Side = { readonly value: number | null; readonly coverage: { readonly state: Coverage["state"] } };
export function moved(now: Side, before: Side | undefined): { readonly by: number; readonly share: number } | undefined {
  if (before === undefined || now.value === null || before.value === null || before.value === 0) return undefined;
  if (now.coverage.state === "faltando" || before.coverage.state === "faltando") return undefined;
  return { by: now.value - before.value, share: now.value / before.value - 1 };
}
